import { render, staticRenderFns } from "./ClientMedicalNote.vue?vue&type=template&id=1e4d20d4"
import script from "./ClientMedicalNote.vue?vue&type=script&lang=js"
export * from "./ClientMedicalNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports